import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b9a8d54"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "section-header"
};
const _hoisted_2 = {
  class: "section-header__title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon-arrow icon-back"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回", -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "section-header__buttons"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_ellipsis_text = _resolveComponent("ellipsis-text");
  const _component_t_button = _resolveComponent("t-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.back ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", {
    class: "back-button",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.handleBackBtnClick && _ctx.handleBackBtnClick(...args))
  }, _hoisted_5), _ctx.title ? (_openBlock(), _createBlock(_component_el_divider, {
    key: 0,
    class: "divider",
    direction: "vertical"
  })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "title-before", {}, undefined, true), _ctx.title ? (_openBlock(), _createBlock(_component_ellipsis_text, {
    key: 1,
    tag: "h1"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.title), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "title", {}, undefined, true), _renderSlot(_ctx.$slots, "title-after", {}, undefined, true)]), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "buttons-before", {}, undefined, true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
    return _openBlock(), _createBlock(_component_t_button, _mergeProps({
      key: index
    }, button), {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(button.text), 1)]),
      _: 2
    }, 1040);
  }), 128)), _renderSlot(_ctx.$slots, "buttons-after", {}, undefined, true)])]);
}